
export class Contact
{
	contactId: number;
	contactDate: Date;
	contactVOList: Contact[];
    emailAddress: any;
	mobilePhone: string;
	phone2: string;
	fullName: string;
	firstName: string;
	lastName: string;
  subjAdrStreet: string;
  mailAdrStreet: string;
  mailAdrStreet2: string;
  mailAdrCity: string;
  mailAdrState: string;
  mailAdrCountry: string;
  mailAdrPostalCode: string;
}
